import React from 'react'
import { Grid, Typography } from '@mui/material'
import Avatar from '@mui/material/Avatar'
import initials from 'initials'
import { useStyles } from './style'

const defaultColors = [
  '#2ecc71', // emerald
  '#3498db', // peter river
  '#8e44ad', // wisteria
  '#e67e22', // carrot
  '#e74c3c', // alizarin
  '#1abc9c', // turquoise
  '#2c3e50' // midnight blue
]

const defaultName = 'the Mindtools Content Team'

const Creator = ({ name, author = false }) => {
  const creatorName = React.useMemo(
    () => (author ? (name?.length > 0 ? name : defaultName) : name),
    [name, author]
  )
  const backgroundColor = defaultColors[creatorName.length % defaultColors.length]
  const classes = useStyles({ backgroundColor })

  if (!creatorName) {
    return null
  }

  return (
    <Grid
      container
      alignItems='baseline'
      wrap='nowrap'
      spacing={2}
      className={classes.root}
    >
      <Grid item>
        <Avatar className={classes.avatar}>
          {creatorName === defaultName ? initials(creatorName.slice(3)) : initials(creatorName)}
        </Avatar>
      </Grid>
      <Grid item className={classes.name}>
        <Typography noWrap data-test='article-author-name'>
          <a
            className={classes.link}
            href='https://www.mindtools.com/content/people-process/'
            target='_blank'
            rel='noreferrer'
          >
            {author ? 'Written by' : 'Reviewed by'} {creatorName}
          </a>
        </Typography>
      </Grid>
    </Grid>
  )
}

export default Creator
